import { Box } from '@chakra-ui/react'
import type { AppInfoMessage } from 'BrokerTsLib/src/dtos'

import { NewsItem } from './NewsItem'

interface INewsList {
  news?: Array<AppInfoMessage>
}

export const NewsGrid = ({ news }: INewsList) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          base: '1fr',
          md: 'repeat(2, 1fr)',
          xl: 'repeat(3, 1fr)',
        },
        gap: 8,
      }}
    >
      {news &&
        news.length > 0 &&
        news.map((msg) => {
          return (
            <NewsItem
              variant="grid"
              key={msg.id}
              showReadButton
              tagLabel={msg.type}
              maxLines={3}
              {...msg}
            />
          )
        })}
    </Box>
  )
}
